import { render, staticRenderFns } from "./ResultadoCargaLiquida.vue?vue&type=template&id=28a5d944&scoped=true&"
import script from "./ResultadoCargaLiquida.vue?vue&type=script&lang=js&"
export * from "./ResultadoCargaLiquida.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoCargaLiquida.vue?vue&type=style&index=0&id=28a5d944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5d944",
  null
  
)

export default component.exports